import { DateTime } from "luxon";
import { DoorRef } from "../../shared/refs";
import { DoorComponent } from "./doorComponent";
import { isNotNullOrUndefined } from "../../../shared/utils/utils";

export class PredictiveService {
  // Predictive Service is just a Door Component with data structured differently
  id?: string | undefined;
  doorLabel?: string;
  doorComponentLabel?: string;
  uptimeMaintenance?: number | null;
  maxOperatingTime?: number | null;
  currentInspectionLoadChanges?: number | null;
  maintenanceDuringLoadChanges?: number | null;
  currentReplacementLoadChanges?: number | null;
  maxLoadChanges?: number | null;
  daysToNextInspection?: number;
  daysToNextReplacement?: number;
  gateSystem?: DoorRef;
  currentDoorLoadChanges?: number;
  startDate?: number;
  dateOfInspection?: number;

  constructor(doorComponent: DoorComponent) {
    this.gateSystem = doorComponent.gateSystem;

    if (doorComponent.uptimeMaintenance) {
      this.daysToNextInspection = this.getDaysToNextInspection(
        doorComponent.startDate!,
        doorComponent.uptimeMaintenance!,
        doorComponent.dateOfInspection
      );
    }

    if (doorComponent.maxOperatingTime) {
      this.daysToNextReplacement = this.getDaysToNextReplacement(
        doorComponent.startDate!,
        doorComponent.maxOperatingTime!,
        doorComponent.dateOfReplacement
      );
    }

    this.id = doorComponent.id?.toString();
    this.doorLabel = doorComponent.gateSystem?.label ? doorComponent.gateSystem?.label : "";
    this.doorComponentLabel = doorComponent.label;
    this.uptimeMaintenance = doorComponent.uptimeMaintenance ? doorComponent.uptimeMaintenance : null;
    this.maxOperatingTime = doorComponent.maxOperatingTime ? doorComponent.maxOperatingTime : null;
    this.currentInspectionLoadChanges = doorComponent.currentInspectionLoadChanges
      ? doorComponent.currentInspectionLoadChanges
      : null;
    this.currentInspectionLoadChanges =
      doorComponent.maintenanceDuringLoadChanges !== null && doorComponent.maintenanceDuringLoadChanges !== 0
        ? doorComponent.currentInspectionLoadChanges
        : null;
    this.maintenanceDuringLoadChanges = doorComponent.maintenanceDuringLoadChanges
      ? doorComponent.maintenanceDuringLoadChanges
      : null;
    this.currentReplacementLoadChanges =
      doorComponent.maxLoadChanges !== null && doorComponent.maxLoadChanges !== 0
        ? doorComponent.currentReplacementLoadChanges
        : null;
    this.maxLoadChanges = doorComponent.maxLoadChanges ? doorComponent.maxLoadChanges : null;
    this.startDate = doorComponent.startDate;
    if (isNotNullOrUndefined(doorComponent.dateOfInspection)) {
      this.dateOfInspection = doorComponent.dateOfInspection;
    }
  }

  /**
   * Sets the current load changes of the door and updates the predictive maintenance days.
   * @param realtimeLoadChanges the new load changes of the door
   */
  public setRealtimeLoadChanges(realtimeLoadChanges: number) {
    if (this.currentDoorLoadChanges === undefined) {
      this.currentDoorLoadChanges = realtimeLoadChanges;
    } else {
      const diff = realtimeLoadChanges - this.currentDoorLoadChanges;
      if (isNotNullOrUndefined(this.currentInspectionLoadChanges)) {
        this.currentInspectionLoadChanges += diff;
      }
      if (isNotNullOrUndefined(this.currentReplacementLoadChanges)) {
        this.currentReplacementLoadChanges += diff;
      }
      this.currentDoorLoadChanges = realtimeLoadChanges;
    }
  }

  getDaysToNextInspection(startDate: number, uptimeMaintenance: number, dateOfInspection?: number | null) {
    const now = DateTime.now().toMillis();
    let startingPoint = startDate;
    if (dateOfInspection !== undefined && dateOfInspection !== null) {
      startingPoint = dateOfInspection;
    }
    const inspection = startingPoint + uptimeMaintenance * 24 * 60 * 60 * 1000;
    const daysToNextInspection = Math.round((inspection - now) / (24 * 60 * 60 * 1000));
    return daysToNextInspection;
  }
  getDaysToNextReplacement(startDate: number, maxOperatingTime: number, dateOfReplacement?: number | null) {
    const now = DateTime.now().toMillis();
    const startingPoint = dateOfReplacement || startDate;
    const replacement = startingPoint + maxOperatingTime * 24 * 60 * 60 * 1000;
    const daysToNextReplacement = Math.round((replacement - now) / (24 * 60 * 60 * 1000));
    return daysToNextReplacement;
  }
}
